export enum ProfileActionTypes {
    ADD_CURRENT_USER_PROFILE="ADD_CURRENT_USER_PROFILE",
    ADD_LOGGED_IN_USER_PROFILE="ADD_LOGGED_IN_USER_PROFILE"
}